angular.module('unica_event.event_services')

.factory('EventEditService', function ($http, getBaseApiURL) {

	var eventEditService = {};

	eventEditService.update = function (eventData) {

		return $http({
			method: 'POST',
			url: getBaseApiURL + '/event/update/' + eventData.id,
			data: eventData
		}).then(function(result) {

			if ( result ) {
				return result.data.event;
			}

		});

	};

	eventEditService.updateTexts = function (eventData) {

		return $http({
			method: 'POST',
			url: getBaseApiURL + '/event/update-texts/' + eventData.id,
			data: eventData
		}).then(function(result) {

			if ( result ) {
				return result.data.event;
			}

		});

	};

	eventEditService.archive = function (eventId) {

		return $http({
			method: 'POST',
			url: getBaseApiURL + '/event/archive/' + eventId,
			data: { }
		}).then(function(result) {

			if ( result ) {
				return result.data.event;
			}

		});

	};

	return eventEditService;
});